type ErrorHandlerFunc = (e: Error, reportToSlardar?: boolean) => void;
const newAssertionError = (props: { name: string; message: string; error?: Error }) => {
  const assertionError = new Error();
  const { name, message, error } = props;
  assertionError.message = message;
  assertionError.name = name;
  if (error) {
    assertionError.message += `\n- ${error.message}`;
  }
  return assertionError;
};

const state = {
  errorHandler: (error: Error, reportToSlardar?: boolean) => console.info(error),
};

export const assert = async (
  value: boolean | Promise<boolean> | (() => boolean | Promise<boolean>),
  message: string,
  reportToSlardar?: boolean,
) => {
  let result;
  let error: Error | undefined;
  if (typeof value === 'boolean') {
    result = value;
  } else if (value instanceof Promise) {
    try {
      result = await value;
    } catch (e) {
      result = false;
      error = e;
    }
  } else if (typeof value === 'function') {
    try {
      result = await value();
    } catch (e) {
      result = false;
      error = e;
    }
  }
  if (result !== true) {
    state.errorHandler(
      newAssertionError({
        name: 'AssertionError',
        message,
        error,
      }),
      reportToSlardar,
    );
  }
};

export const setErrorHandler = (handler: ErrorHandlerFunc) => {
  state.errorHandler = handler;
};
